export enum Widget {
  Tracking = 'Tracking',
  TradeRoute = 'Trade Route',
  InfoBoard = 'Info Board',
}
